module.exports = __webpack_public_path__ + "static/media/Icon.444a9e53.png";